import { ColumnConfigItemType  } from "../../../../../../utils/datatype";
import BudgetShow from "./budget_show";
import { getBudgetDataFromFB, getBudgetDataFromGoogle } from "../../../../service";


type BudgetProps = {
    platform: string
}

const columnConfigForGoogle : Array<ColumnConfigItemType> = [
    {
        dataIndex: 'id',
        title: 'ID',
        className: 'td-column',
        isShow: true,
        width: 80,
        canSearch: true,
        sorter: {
            compare: (a: any, b: any) => a.id - b.id
        }
    },
    {
        dataIndex: 'customerId',
        title: '客户ID',
        className: 'td-column',
        isShow: true,
        width: 140,
        canSearch: true,
    },
    {
        dataIndex: 'camId',
        title: '广告系列ID',
        className: 'td-column',
        isShow: true,
        width: 140,
        canSearch: true,
    },
    {
        dataIndex: 'camName',
        title: '广告系列名称',
        className: 'td-column',
        isShow: true,
        width: 140,
        canSearch: true,
    },
    {
        dataIndex: 'cost',
        title: '花费',
        className: 'td-column',
        isShow: true,
        width: 80,
        sorter: {
            compare: (a: any, b: any) => a.cost - b.cost
        }
    },
    {
        dataIndex: 'revenue',
        title: '收入',
        className: 'td-column',
        isShow: true,
        width: 80,
        sorter: {
            compare: (a: any, b: any) => a.cost - b.cost
        }
    },
    {
        dataIndex: 'roi',
        title: 'roi',
        className: 'td-column',
        isShow: true,
        width: 80,
        sorter: {
            compare: (a: any, b: any) => a.cost - b.cost
        }
    },
    {
        dataIndex: 'budgetOld',
        title: '调整前',
        className: 'td-column',
        isShow: true,
        width: 100,
        sorter: {
            compare: (a: any, b: any) => a.cost - b.cost
        }
    },
    {
        dataIndex: 'budgetNew',
        title: '调整后',
        className: 'td-column',
        isShow: true,
        width: 100,
    },
    {
        dataIndex: 'labelUrl',
        title: '渠道',
        className: 'td-column',
        isShow: true,
        canSearch: true,
        width: 120,
    },
    {
        dataIndex: 'countryCode',
        title: '国家编码',
        className: 'td-column',
        isShow: true,
        width: 100,
    },
    {
        dataIndex: 'note',
        title: '备注',
        className: 'td-column',
        isShow: true,
        width: 120,
    },
    {
        dataIndex: 'queryHour',
        title: '调整时间点',
        className: 'td-column',
        isShow: true,
        width: 120,
        sorter: {
            compare: (a: any, b: any) => a.roi - b.roi
        }
    },
    {
        dataIndex: 'queryDate',
        title: '调整日期',
        className: 'td-column',
        isShow: true,
        width: 120,
        render: (value) => {
            return <span>{value}</span>
        },
        canSearch: true,
        searchType: 'time'
    }
];

const defaultParamsForGoogle = {
    adAccountId: null,
    customerId: null,
    camId: null,
    camName: null
};

const columnConfigForFacebook : Array<ColumnConfigItemType> = [
    {
        dataIndex: 'id',
        title: 'ID',
        className: 'td-column',
        isShow: true,
        width: 80,
        canSearch: true,
        sorter: {
            compare: (a: any, b: any) => a.id - b.id
        }
    },
    {
        dataIndex: 'adAccountName',
        title: '广告账户名称',
        className: 'td-column',
        isShow: true,
        width: 140,
        canSearch: true,
    },
    {
        dataIndex: 'adSetName',
        title: '广告组名称',
        className: 'td-column',
        isShow: true, 
        width: 120,
        canSearch: true,
    },
    {
        dataIndex: 'adSetRoi',
        title: '广告组roi',
        className: 'td-column',
        isShow: true,
        width: 80,
        sorter: {
            compare: (a: any, b: any) => a.roi - b.roi
        }
    },
    {
        dataIndex: 'cost',
        title: '成本',
        className: 'td-column',
        isShow: true,
        width: 80,
        sorter: {
            compare: (a: any, b: any) => a.cost - b.cost
        }
    },
    {
        dataIndex: 'budgetOld',
        title: '原预算',
        className: 'td-column',
        isShow: true,
        width: 80,
        sorter: {
            compare: (a: any, b: any) => a.cost - b.cost
        }
    },
    {
        dataIndex: 'budgetNew',
        title: '新预算',
        className: 'td-column',
        isShow: true,
        width: 120,
    },
    {
        dataIndex: 'note',
        title: '调整日志',
        className: 'td-column',
        isShow: true,
        width: 100,
    },
    {
        dataIndex: 'queryHour',
        title: '调整时间点',
        className: 'td-column',
        isShow: true,
        width: 100,
        sorter: {
            compare: (a: any, b: any) => a.roi - b.roi
        }
    },
    {
        dataIndex: 'queryDate',
        title: '调整日期',
        className: 'td-column',
        isShow: true,
        width: 100,
        render: (value) => {
            return <span>{value}</span>
        },
        canSearch: true,
        searchType: 'time'
    }
];

const defaultParamsForFacebook = {
    adAccountName: null,
    adSetName: null,
    adjustmentDate: null
};


const BudgetTable = ({platform}: BudgetProps) => {
    const getPlatformInfo = (platform:string) => {
        const googleInfo = {
            columnConfig: columnConfigForGoogle,
            queryParams: defaultParamsForGoogle,
            dataHandler: getBudgetDataFromGoogle
        };
        const facebookInfo = {
            columnConfig: columnConfigForFacebook,
            queryParams: defaultParamsForFacebook,
            dataHandler: getBudgetDataFromFB
        };
        switch(platform) {
            case 'google':
                return googleInfo;
            case 'facebook':
                return facebookInfo;
            default:
                return facebookInfo;
        }
    }; 
    const currentProps: any = getPlatformInfo(platform);
    return (
        <BudgetShow  columnConfig={currentProps.columnConfig} dataHandler={currentProps.dataHandler} queryParams={currentProps.queryParams} />
    );
};

export default BudgetTable;